import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth"
import { getFirestore } from "firebase/firestore"
import { getStorage } from 'firebase/storage'


const firebaseConfig = {
    apiKey: "AIzaSyAoohv-W-hzF9BySGQMm2sfwrozu_PYjOM",
    authDomain: "daenmangkorn.firebaseapp.com",
    projectId: "daenmangkorn",
    storageBucket: "daenmangkorn.appspot.com",
    messagingSenderId: "321785817426",
    appId: "1:321785817426:web:418fc13a293b05b8e7728b",
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app)
const auth = getAuth(app)
const storage = getStorage(app)

export { app, db, auth, storage }